import React from "react";
import Skeleton from "../shared/skeleton-component";

const OperatorsSelectSkeleton = () => {
  return (
    <div className="operator-select-skeleton">
      <Skeleton width="360px" height="50px" />
    </div>
  );
};

export default OperatorsSelectSkeleton;
